import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import ValuesSection from './components/ValuesSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'Rm Software',
            description:
              'Professional engineering team focused on designing and developing modern digital software solutions for the iOS platform and related technologies.',
            url: 'https://rmsssoftware.com',
            address: {
              '@type': 'PostalAddress',
              streetAddress: '475 Salem Avenue North, Apartment 10',
              addressLocality: 'Toronto',
              addressRegion: 'Ontario',
              postalCode: 'M6H 3C9',
              addressCountry: 'Canada',
            },
            telephone: '+1 2493155173',
            email: 'ceo@rmsssoftware.com',
          }),
        }}
      />
      <main className="relative min-h-screen">
        <Navbar />
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <ValuesSection />
        <ContactSection />
        <Footer />
      </main>
    </>
  );
}